import { useQuery } from "@apollo/client";
import { GET_PLAN_KPIS} from "../api/queries";

export default function usePlanKpiDataQuery(projectId: string, batchId: string) {
    const query = useQuery(GET_PLAN_KPIS, { variables: { projectId, batchId } })

    return { ...query, data: (query.data && query.data.planKpi) ? query.data.planKpi : {}}
}